import { Divider, Grid } from "@mui/material";
import { ReportingCheckbox } from "./ReportingCheckbox/ReportingCheckbox";
import useStyles from "./ReportingCheckboxGroup.styles";

export const ReportingCheckboxGroup = ({
  title,
  columns,
  setColumns,
}: {
  title: string;
  columns: { id: string; label: string; checked?: boolean }[];
  setColumns: React.Dispatch<
    React.SetStateAction<{ id: string; label: string; checked: boolean }[]>
  >;
}) => {
  const classes = useStyles();

  const chunkSize = Math.ceil(columns.length / 3);

  const group1 = columns.slice(0, chunkSize);
  const group2 = columns.slice(chunkSize, chunkSize * 2);
  const group3 = columns.slice(chunkSize * 2);

  const update = async (key: string, value: boolean) => {
    setColumns((state) => {
      return state.map((c) => {
        if (c.id === key) return { ...c, checked: value };
        return { ...c };
      });
    });
  };

  return (
    <>
      <Grid item container className={classes.container}>
        <Divider textAlign="left" style={{ width: "100%" }}>
          {title}
        </Divider>
        <Grid flexDirection={"column"} style={{ width: "33%" }}>
          {group1.map((g) => (
            <ReportingCheckbox
              key={g.id}
              id={g.id}
              label={g.label}
              checked={g.checked}
              update={update}
            />
          ))}
        </Grid>
        <Grid flexDirection={"column"} style={{ width: "33%" }}>
          {group2.map((g) => (
            <ReportingCheckbox
              key={g.id}
              id={g.id}
              label={g.label}
              checked={g.checked}
              update={update}
            />
          ))}
        </Grid>
        <Grid flexDirection={"column"} style={{ width: "33%" }}>
          {group3.map((g) => (
            <ReportingCheckbox
              key={g.id}
              id={g.id}
              label={g.label}
              checked={g.checked}
              update={update}
            />
          ))}
        </Grid>
      </Grid>
    </>
  );
};
